import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  ButtonGroup,
  Button,
} from "react-bootstrap";
import { ThreeDots } from 'react-loader-spinner';
import { getServiceLengths } from "../../3.Store/ServiceLengthsSlice";
import { getCatagories } from "../../3.Store/EmployeeCatagoriesSlice";

const EmployeeCatagoriesList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const catagories = useSelector((state) => state.EmployeeCatagoriesSlice.employeeCatagories);
  const [loading, setLoading] = useState(false);
  const role = JSON.parse(localStorage.getItem("roles"));

  useEffect(() => {
    setLoading(true);

    if (!role || !role.includes("HR-L-AWARD")) {
      localStorage.clear();
      window.location.href = "/Login";
    }

    dispatch(getCatagories())
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });

  }, [])

  const handleBtnBack = () => {
    navigate("/");
  };

  const handleBtnCreate = () => {
    navigate(`/EmployeeCatagoriesAdd`);
  };

  const renderLengthList = () => {
    return catagories.map(catagory => (
      <tr key={catagory?.id} style={{ cursor: "pointer" }}>
        <td>{catagory?.id}</td>
        <td>{catagory?.short_description}</td>
        <td>{catagory?.description}</td>
      </tr>
    ));
  };

  return (
    <div className="ContainerContent2">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">Employee Category</h1>
        <h1 className="MiniTitleHeader">List</h1>

        <div style={{ overflowX: 'auto' }}>
          <Table borderless className="mt-3 my-fixed-table text-center" style={{ fontSize: "14px", cursor: "pointer" }}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Short Description</th>
                <th>Description</th>
              </tr>
            </thead>
            {!loading && (
              <tbody>
                {catagories.length > 0 ? (
                  renderLengthList()
                ) : (
                  <tr>
                    <td colSpan="2">No results found</td>
                  </tr>
                )}
              </tbody>
            )}
          </Table>
        </div>

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          &nbsp; &nbsp;
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnCreate}>
              Add
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </div>
  );
};
export default EmployeeCatagoriesList;